<script>
/* eslint-disable */
import Layout from '@layouts/primary'
import { invoiceMethods, messageMethods } from '@state/helpers'
import moment from 'moment-timezone'
import ListLoading from '../../components/loading'
export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'Messages',
    meta: [{ name: 'description', content: 'Messages' }],
  },
  components: { Layout, ListLoading },
  data() {
    return {
      expanded: {},
      loadingData: true,
      search: '',
      headers: [
        { text: 'Client', value: 'client.client_name', width: '15%' },
        { text: 'Mobile Number', value: 'to_number', width: '15%' },
        { text: 'Date Sent', value: 'formatted_date',width: '15%'  },
        { text: 'Message', value: 'body',width: '55%'  },
      ],
      messages: [],
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)

    this.getMessages().then(response=>{
      let obj = this.$store.state.messages.objects
      for (let v in obj) {
        obj[v].formatted_date = moment.unix(obj[v].created_at/1000).format("DD/MM/YYYY")
        this.messages.push(obj[v])
      }
      this.loadingData=false
    // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      this.loadingData=false
    })

  },
  methods: {
    ...messageMethods,
    submit() {

    },
    clear() {

    },
    changeRoute(r) {
      this.$router.push(r)
    },
  }
}
</script>

<template>
  <Layout>
    <VContainer>
      <div class="">
        <h2 :class="$style.routeHeader">
          Messages
        </h2>
        <ListLoading :display="loadingData" />
      </div>
      <VLayout style="width: 100%">

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-if="!loadingData"
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>
      <VFlex
        xs0
        sm12
      >
        <VDataTable
          v-if="!loadingData"
          :headers="headers"
          :items="messages"
          :search="search"
          rows-per-page-text=""
          :rows-per-page-items="[10]"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <tr @click="expanded[props.item.invoice_number] = !expanded[props.item.invoice_number]">
              <td class="text-xs-left">
                {{ props.item.client.client_name }}
              </td>
              <td class="text-xs-left">
                {{ props.item.to_number }}
              </td>
              <td class="text-xs-left">
                {{ props.item.formatted_date }}
              </td>
              <td class="text-xs-left">
                {{ props.item.body }}
              </td>

            </tr>

          </template>
        </VDataTable>
      </VFlex>
    </VContainer>

  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.routeHeader {
  display: inline-block;
}

.addButton {
  display: inline-block;
  float: right;
}
</style>
